import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import { Tooltip as MuiTooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const UnitsOutstandingCard = ({ data }) => {
  const [unitsOutstanding, setUnitsOutstanding] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!data) return;

    const unitsOutstandingData = data.map(item => ({
      Unit: item.unit.unitNumber,
      OwnerName: item.invoiceId.issuedBy.user.givenName + " " + item.invoiceId.issuedBy.user.lastName,
      Amount: item.outstandingBalance,
      DueDate: `${new Date(item.invoiceId.dueDate).toLocaleDateString()}`
    }));

    setUnitsOutstanding(unitsOutstandingData);

  }, [data]);

  const handleNavigate = () => {
    navigate('/portfolio');
  }

  return (
    <div className="card" style={{ width: "100%" }}>
      <div className="tooltip-header" style={{ display: "flex", alignItems: "center" }}>
        <MuiTooltip title="These are the outstanding balances of a unit." arrow>
          <IconButton>
            <HelpOutlineIcon sx={{ fontSize: '18px', color: 'grey' }} />
          </IconButton>
        </MuiTooltip>
        <button className="redirect-btn" onClick={handleNavigate}>
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        </button>
      </div>

      <h2 className="card-title"><i className="fas fa-file-invoice-dollar" />Outstanding Balances</h2>

      <table className="dashboard-table">
        <thead>
          <tr>
            <th>Unit</th>
            <th>Owner Name</th>
            <th>Earliest Due Date</th>
            <th>Outstanding Amount</th>
          </tr>
        </thead>
        <tbody>
          {unitsOutstanding.length > 0 ? (
            unitsOutstanding.map((item, index) => (
              <tr key={index}>
                <td>{item.Unit}</td>
                <td>{item.OwnerName}</td>
                <td>{item.DueDate}</td>
                <td>PHP {item.Amount.toFixed(2)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>No outstanding leases found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UnitsOutstandingCard;